const doc = [({"en":({"js":({"merfoto":({"layout":({"footer":({"index":({"pay_with":"Pay with"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;